import { Injectable } from '@angular/core';
import { ASidebarBuilder } from './a-sidebar-builder';
import { UserInfo } from '../../../../shared/models/auth/user-info.model';
import { SidebarMenuContainer } from './../models/sidebar-menu-container.model';
import { SidebarMenuItem } from './../models/sidebar-menu-item.model';

@Injectable()
export class PpSidebarBuilder extends ASidebarBuilder {
  protected rebuildProgramMenu(userInfo: UserInfo): void {
    const content = new Array<SidebarMenuItem | SidebarMenuContainer>();

    if (userInfo.CurrentProgramId !== null) {
      if (userInfo.IsTrainee && !userInfo.IsSiteAdmin && !userInfo.IsSysAdmin && !userInfo.IsObserver) {
        content.push(
          new SidebarMenuItem({
            name: 'Dashboard',
            icon: 'dashboard',
            isActive: this.routeHelper.dashboardActive.bind(this.routeHelper),
            action: this.routeHelper.dashboard.bind(this.routeHelper, userInfo.CurrentProgramRoleId)
          })
        );
      }

      if (!userInfo.IsTrainee || userInfo.IsSiteAdmin || userInfo.IsObserver) {
        content.push(
          new SidebarMenuItem({
            name: 'Dashboard',
            icon: 'arrow-to-right',
            style: { transform: 'rotate(180deg)' },
            isActive: this.routeHelper.dashboardActive.bind(this.routeHelper),
            hidden: () => !(this.routeHelper.formInstanceActive() || this.routeHelper.quizInstanceActive()),
            action: this.routeHelper.dashboard.bind(this.routeHelper)
          })
        );
      }

      if (!userInfo.IsTrainee || userInfo.IsSiteAdmin || userInfo.IsSysAdmin || userInfo.IsObserver) {
        content.push(
          new SidebarMenuItem({
            icon: 'users',
            name: 'Users',
            isActive: this.routeHelper.programUsersListActive.bind(this.routeHelper),
            action: this.routeHelper.programUsersList.bind(this.routeHelper)
          })
        );
      }

      if (userInfo.IsSysAdmin || userInfo.IsSiteAdmin || userInfo.IsCoordinator || userInfo.IsObserver) {
        content.push(
          new SidebarMenuItem({
            icon: 'signal',
            name: 'Reports',
            isActive: this.routeHelper.ppReportsActive.bind(this.routeHelper),
            action: this.routeHelper.ppReports.bind(this.routeHelper)
          })
        );
      }

      content.push(
        new SidebarMenuItem({
          icon: 'file',
          name: 'Resources',
          isActive: this.routeHelper.resourcesActive.bind(this.routeHelper),
          action: this.routeHelper.resources.bind(this.routeHelper)
        })
      );

      content.push(
        new SidebarMenuItem({
          icon: 'search',
          name: 'Search',
          isActive: this.routeHelper.searchActive.bind(this.routeHelper),
          action: this.routeHelper.search.bind(this.routeHelper)
        })
      );
    }

    this.programMenuContent = content;
  }

  protected rebuildProgramSettingsMenu(
    userInfo: UserInfo,
    content: Array<SidebarMenuItem | SidebarMenuContainer>
  ): void {
    if (userInfo.IsSysAdmin || userInfo.IsSiteAdmin || userInfo.IsCoordinator) {
      const programSetupSubMenu = new SidebarMenuContainer({
        icon: 'tools',
        name: 'Program Settings'
      });

      programSetupSubMenu.sublings.push(
        new SidebarMenuItem({
          name: 'Forms',
          isActive: this.routeHelper.ppFormsActive.bind(this.routeHelper),
          action: this.routeHelper.ppForms.bind(this.routeHelper)
        })
      );

      programSetupSubMenu.sublings.push(
        new SidebarMenuItem({
          name: 'Performance',
          isActive: this.routeHelper.performanceActive.bind(this.routeHelper),
          action: this.routeHelper.performanceCategories.bind(this.routeHelper)
        })
      );

      programSetupSubMenu.sublings.push(
        new SidebarMenuItem({
          name: 'Alerts',
          isActive: this.routeHelper.alertsActive.bind(this.routeHelper),
          action: this.routeHelper.alerts.bind(this.routeHelper)
        })
      );

      content.push(programSetupSubMenu);
    }
  }
}
